import { render, staticRenderFns } from "./UploadDocumentDialog.vue?vue&type=template&id=077e1630&scoped=true"
import script from "./UploadDocumentDialog.vue?vue&type=script&lang=js"
export * from "./UploadDocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentDialog.vue?vue&type=style&index=0&id=077e1630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077e1630",
  null
  
)

export default component.exports